import feCommonDataHolder from '../fe-common.initialize.js';

const REGION_ID_HEADER = 'x-gctx-request-origin-region-id';
const REGION_LANG_HEADER = 'x-gctx-request-origin-locale';
const REGION_DETAILS_LOCAL_STORAGE_KEY = 'REGION_DETAILS';
const isBrowser = ()=>typeof window !== 'undefined';
const getFromLocalStorageWithExpiry = (key)=>{
    if (typeof localStorage === 'undefined') return null;
    try {
        const val = localStorage.getItem(key);
        if (val) {
            const data = JSON.parse(val);
            return data?.value;
        }
    } catch (error) {
        console.info('getFromLocalStorageWithExpiry error', error, key);
    }
    return null;
};
const getLocalisationDataFromStorage = ()=>{
    const { enableI18n } = feCommonDataHolder.getFlags();
    if (!enableI18n) return null;
    if (!isBrowser()) return null;
    return JSON.parse(getFromLocalStorageWithExpiry(REGION_DETAILS_LOCAL_STORAGE_KEY) ?? 'null');
};
const LOCALE_FORMAT = '{{language}}-{{country}}';
function parseFormat(format, input) {
    const varNames = [];
    let matchCount = 0;
    const regexPattern = format.replace(/{{(.*?)}}/g, (_, varName)=>{
        varNames.push(varName);
        matchCount++;
        return '(.+?)' // non-greedy capture group
        ;
    });
    const regex = new RegExp(`^${regexPattern}$`);
    const match = input.match(regex);
    if (!match || match.length < matchCount + 1) return null;
    const result = {};
    varNames.forEach((name, index)=>{
        result[name] = match[index + 1] ?? '';
    });
    return result;
}
const parseLocale = (locale)=>{
    return parseFormat(LOCALE_FORMAT, locale);
};
const getStandardLocale = (locale)=>{
    const parsedLocale = parseLocale(locale);
    return `${parsedLocale.language}-${parsedLocale.country.toUpperCase()}`;
};

export { LOCALE_FORMAT, REGION_DETAILS_LOCAL_STORAGE_KEY, REGION_ID_HEADER, REGION_LANG_HEADER, getFromLocalStorageWithExpiry, getLocalisationDataFromStorage, getStandardLocale, parseFormat, parseLocale };
//# sourceMappingURL=utils.js.map
